(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function () {
  if (window.__recsTabsInit) return;
  window.__recsTabsInit = true;

  var STORAGE_KEY = 'recently_viewed_products';

  // ===== AUTOPLAY SETTINGS =====
  var CARD_SLIDER_AUTOPLAY = false; // true karoge to card ke andar images auto-change hongi
  var GRID_AUTOPLAY = false;        // true karoge to grid apne aap next card par scroll hoga
  var CARD_SLIDER_DELAY = 6000;     // 6 seconds
  var GRID_AUTOPLAY_DELAY = 5000;   // 5 seconds

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, window.themeMoneyFormat || undefined); } catch (e) {}
    }
    var amount = Math.round(cents / 100);
    return 'Rs. ' + amount.toLocaleString('en-IN');
  }

  function priceHTML(p) {
    var price = p.price;
    var compareAt = p.compare_at_price;
    var onSale = compareAt && compareAt > price;
    var cls = 'price' + (onSale ? ' on-sale' : '') + (p.available ? '' : ' sold-out');

    if (onSale) {
      return (
        '<coretex-price class="' + cls + '" x-flex direction="row" ai="center">' +
          '<price-sale class="price-sale" x-flex direction="row" wrap="wrap" style="gap: 0 var(--mardding)">' +
            '<x-cell>' +
              '<span class="visually-hidden">Regular price</span>' +
              '<s class="price-item regular">' + formatMoney(compareAt) + '</s>' +
            '</x-cell>' +
            '<x-cell>' +
              '<span class="visually-hidden">Sale price</span>' +
              '<span class="price-item sale">' + formatMoney(price) + '</span>' +
            '</x-cell>' +
          '</price-sale>' +
        '</coretex-price>'
      );
    }

    return (
      '<coretex-price class="' + cls + '" x-flex direction="row" ai="center">' +
        '<price-regular class="price-regular" x-flex direction="row" pi="center">' +
          '<x-cell>' +
            '<span class="visually-hidden">Regular price</span>' +
            '<span class="price-item regular">' + formatMoney(price) + '</span>' +
          '</x-cell>' +
        '</price-regular>' +
      '</coretex-price>'
    );
  }

  function sizedImg(url, width) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function mediaSliderHTML(p) {
    var images = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean).slice(0, 6);
    if (!images.length) images = [''];
    var count = images.length;
    var safeTitle = p.title.replace(/"/g, '&quot;');

    var slidesHTML = images.map(function (src, i) {
      return '<div class="rv-slider-slide' + (i === 0 ? ' is-active' : '') + '" data-rv-slider-slide data-index="' + i + '">' +
        '<img src="' + sizedImg(src, 600) + '" alt="' + safeTitle + '" loading="eager" width="750" height="1000">' +
      '</div>';
    }).join('');

    var arrowsHTML = '';
    var scrollbarHTML = '';
    if (count > 1) {
      arrowsHTML =
        '<button type="button" class="rv-slider-arrow rv-slider-arrow--prev" data-rv-slider-prev aria-label="Previous image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
            '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 12H4m0 0 6 6m-6-6 6-6"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="rv-slider-arrow rv-slider-arrow--next" data-rv-slider-next aria-label="Next image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
            '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 12h16m0 0-6-6m6 6-6 6"/>' +
          '</svg>' +
        '</button>';
      scrollbarHTML =
        '<div class="rv-slider-scrollbar" data-rv-slider-scrollbar>' +
          '<div class="rv-slider-scrollbar-thumb" data-rv-slider-thumb style="width:' + (100 / count) + '%"></div>' +
        '</div>';
    }

    return (
      '<div class="rv-media-wrap" data-rv-media-slider data-slide-count="' + count + '">' +
        '<div class="rv-media-slider">' +
          '<div class="rv-slider-track" data-rv-slider-track>' + slidesHTML + '</div>' +
          arrowsHTML +
        '</div>' +
        scrollbarHTML +
      '</div>'
    );
  }

  function initSliders(root) {
    root.querySelectorAll('[data-rv-media-slider]').forEach(function (el) {
      if (el.dataset.rvSliderInit === 'true') return;
      el.dataset.rvSliderInit = 'true';

      var track = el.querySelector('[data-rv-slider-track]');
      var slideEls = Array.prototype.slice.call(el.querySelectorAll('[data-rv-slider-slide]'));
      if (!track || slideEls.length <= 1) return;

      var thumb = el.querySelector('[data-rv-slider-thumb]');
      var prevBtn = el.querySelector('[data-rv-slider-prev]');
      var nextBtn = el.querySelector('[data-rv-slider-next]');

      // Verify every slide's image is fully decoded and ready to PAINT
      // (not just downloaded). Any slide whose image fails is dropped entirely,
      // so arrows/autoplay can never land on a blank frame.
      function whenReady(img) {
        if (img.decode) {
          return img.decode().catch(function () { return Promise.reject(); });
        }
        return new Promise(function (resolve, reject) {
          if (img.complete && img.naturalWidth > 0) return resolve();
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', reject, { once: true });
        });
      }

      // Safety net: decode()/load can occasionally hang and never settle.
      // After the timeout we proceed anyway.
      function withTimeout(promise, ms) {
        return new Promise(function (resolve) {
          var settled = false;
          var timer = setTimeout(function () {
            if (!settled) { settled = true; resolve(); }
          }, ms);
          promise.then(
            function () { if (!settled) { settled = true; clearTimeout(timer); resolve(); } },
            function () { if (!settled) { settled = true; clearTimeout(timer); resolve(); } }
          );
        });
      }

      var loadChecks = slideEls.map(function (slide) {
        var img = slide.querySelector('img');
        if (!img) { slide.remove(); return Promise.resolve(); }
        return withTimeout(whenReady(img).catch(function () { slide.remove(); }), 6000);
      });

      Promise.all(loadChecks).then(function () {
        var slides = el.querySelectorAll('[data-rv-slider-slide]');
        var count = slides.length;

        if (count <= 1) {
          // Not enough valid images left — show a single static image, no chrome
          if (prevBtn) prevBtn.remove();
          if (nextBtn) nextBtn.remove();
          var sb = el.querySelector('[data-rv-slider-scrollbar]');
          if (sb) sb.remove();
          return;
        }

        var index = 0;
        var timer;

        function goTo(i) {
          index = ((i % count) + count) % count;
          slides.forEach(function (s, idx) {
            s.classList.toggle('is-active', idx === index);
          });
          if (thumb) thumb.style.transform = 'translateX(' + (index * 100) + '%)';
        }
        // ===== Swipe support (touch) =====
var startX = 0, startY = 0, swiped = false, tracking = false;

el.addEventListener('touchstart', function (e) {
  var t = e.touches[0];
  startX = t.clientX;
  startY = t.clientY;
  swiped = false;
  tracking = true;
}, { passive: true });

el.addEventListener('touchmove', function (e) {
  if (!tracking) return;
  var t = e.touches[0];
  var dx = t.clientX - startX;
  var dy = t.clientY - startY;
  if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swiped = true;
}, { passive: true });

el.addEventListener('touchend', function (e) {
  if (!tracking) return;
  tracking = false;
  var dx = e.changedTouches[0].clientX - startX;
  if (swiped && Math.abs(dx) > 40) {
    goTo(dx < 0 ? index + 1 : index - 1); // left swipe = next, right swipe = previous
    startAutoplay();
  }
}, { passive: true });

// Swipe ke baad product link accidentally open na ho
el.addEventListener('click', function (e) {
  if (swiped) {
    e.preventDefault();
    e.stopPropagation();
    swiped = false;
  }
}, true);  
        function startAutoplay() {
          if (!CARD_SLIDER_AUTOPLAY) return;
          clearInterval(timer);
          timer = setInterval(function () { goTo(index + 1); }, CARD_SLIDER_DELAY);
        }

        if (prevBtn) prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(index - 1);
          startAutoplay();
        });
        if (nextBtn) nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(index + 1);
          startAutoplay();
        });

        goTo(0);
        startAutoplay();
      });
    });
  }

  function cardHTML(p) {
    var safeTitle = p.title.replace(/"/g, '&quot;');
    var url = '/products/' + p.handle;
    var titleWords = p.title.split(' ');
    var titleHtml = '';

    if (titleWords.length > 3) {
      titleHtml = '<span class="title-compact">' + titleWords.slice(0, 3).join(' ') + '...</span>' +
                  '<span class="title-full">' + p.title + '</span>';
    } else {
      titleHtml = p.title;
    }
    return (
      '<product-card class="onHover-a" in-stock="' + (p.available ? 'true' : 'false') + '">' +
        '<x-flex direction="column" class="productCardContainer">' +

          '<x-cell class="media">' +
            '<button type="button" class="wishlist-btn" data-wishlist-toggle data-product-id="' + p.id + '" data-product-handle="' + p.handle + '" aria-label="Add to wishlist">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="icon-heart"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-5-7 5V4a1 1 0 0 1 1-1z"/></svg>' +
            '</button>' +
            '<a href="' + url + '" class="no-style" tabindex="-1" aria-label="' + safeTitle + '">' +
              mediaSliderHTML(p) +
            '</a>' +
          '</x-cell>' +

          '<x-flex direction="column" class="meta">' +
            '<x-flex wrap="wrap" class="header">' +
              '<x-flex wrap="wrap" jc="between" span="4">' +
                '<x-flex direction="column">' +
                  '<x-cell class="title"><h2 class="h4"><a href="' + url + '">' + titleHtml + '</a></h2></x-cell>' +
                '</x-flex>' +
                '<x-cell class="price" ref="price">' + priceHTML(p) + '</x-cell>' +
              '</x-flex>' +
            '</x-flex>' +
          '</x-flex>' +

        '</x-flex>' +
      '</product-card>'
    );
  }

  // Global click delegation on `document` — keeps working no matter
  // when/how the section markup is inserted.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-recs-tab]');
    if (!btn) return;
    var wrapper = btn.closest('product-recommendations') || btn.closest('section');
    if (!wrapper) return;
    var target = btn.getAttribute('data-recs-tab');
    wrapper.querySelectorAll('[data-recs-tab]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    wrapper.querySelectorAll('[data-recs-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.id === target);
    });
  });

  function initGridAutoplay(grid) {
    if (!GRID_AUTOPLAY) return;
    if (!grid || !grid.hasAttribute('hscroll-area')) return;
    if (grid.dataset.gridAutoplayInit === 'true') return;
    grid.dataset.gridAutoplayInit = 'true';

    setInterval(function () {
      var card = grid.querySelector(':scope > *');
      if (!card) return;
      var style = window.getComputedStyle(grid);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      var step = card.getBoundingClientRect().width + gap;
      var maxScroll = grid.scrollWidth - grid.clientWidth;

      if (maxScroll <= 0) return;

      var next = grid.scrollLeft + step;
      if (next >= maxScroll - 5) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollTo({ left: next, behavior: 'smooth' });
      }
    }, GRID_AUTOPLAY_DELAY);
  }

  function renderRecentlyViewed(grid) {
    if (!grid || grid.dataset.rvRendered === 'true') return;
    grid.dataset.rvRendered = 'true';

    var wrapper = grid.closest('product-recommendations');
    var currentHandle = wrapper ? wrapper.getAttribute('data-product-handle') : '';
    var limit = wrapper ? (parseInt(wrapper.getAttribute('data-recent-limit'), 10) || 4) : 4;
    var emptyMsg = grid.parentElement.querySelector('[data-rv-empty]');

    var handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      handles = [];
    }
    handles = handles.filter(function (h) { return h && h !== currentHandle; }).slice(0, limit);

    if (!handles.length) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        if (emptyMsg) emptyMsg.style.display = 'block';
        return;
      }
      products.forEach(function (p) {
        grid.insertAdjacentHTML('beforeend', cardHTML(p));
      });
      initSliders(grid);
      initGridAutoplay(grid);
    });
  }

  function trackCurrentProduct() {
    var wrapper = document.querySelector('product-recommendations[data-product-handle]');
    var handle = wrapper ? wrapper.getAttribute('data-product-handle') : '';
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > 12) list = list.slice(0, 12);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  var trackedThisLoad = false;
  function scanAndRender() {
    if (!trackedThisLoad) {
      trackedThisLoad = true;
      trackCurrentProduct();
    }
    document.querySelectorAll('[data-rv-grid]:not([data-rv-rendered])').forEach(renderRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndRender);
  } else {
    scanAndRender();
  }

  // Whole-page observer — catches the section appearing later, however it's
  // inserted (AJAX swap, lazy section load, infinite-scroll re-render, etc.)
  var bodyObserver = new MutationObserver(function () {
    scanAndRender();
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
